import { ApiResult, EntitiesPaginatedModel, PaginationModel, apiCallWrapper } from "traveldesk-ui";
import HotelsFilter from "../viewModels/HotelsFilter";
import HotelModel from "../models/HotelModel";
import HotelImportModel from "../models/HotelImportModel";
import HotelsImportPreviewResultModel from "../models/HotelsImportPreviewResultModel";
import HotelsImportResultModel from "../models/HotelsImportResultModel";

export default class HotelsApiService {
    public static async getHotels(filter: HotelsFilter, dispatch: any) {
        let result = await apiCallWrapper<EntitiesPaginatedModel<HotelModel>>('/api/hotels', 'POST', dispatch, filter)
        if (result.Content) {
            result.Content.pagingInfo = PaginationModel.Create(result.Content.pagingInfo)
        }
        return result
    }
    public static async getHotel(id: number, dispatch: any) {
        return await apiCallWrapper<HotelModel>(`/api/hotels/${id}`, "GET", dispatch)
    }
    public static async save(hotel: HotelModel, dispatch: any) {
        return await apiCallWrapper<HotelModel>(`/api/hotels`, 'PUT', dispatch, hotel)
    }

    public static async importPreview(file: File): Promise<ApiResult<HotelsImportPreviewResultModel>> {
        const result: ApiResult<HotelsImportPreviewResultModel> = {
            IsOk: true,
            ErrorTitle: '',
            ErrorMessage: '',
            Content: undefined,
            Code: 0,
        }

        try {
            const formData = new FormData()
            formData.append('file', file)
            const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : undefined
            const response = await fetch('/api/hotels/importpreview', {
                method: 'POST',
                body: formData,
                headers: {
                    Authorization: token ? `Bearer ${token}` : '',
                },
            })
            result.Code = response.status
            if (!response.ok) {
                result.IsOk = false
                result.ErrorTitle = response.status.toString()
                result.ErrorMessage = await response.text()
                return result
            }

            const parsed = (await response.json()) as HotelsImportPreviewResultModel
            result.Content = HotelsImportPreviewResultModel.Create(parsed)
            return result
        } catch (e) {
            const error = e as Error
            result.IsOk = false
            result.ErrorTitle = error.message
            result.ErrorMessage = error.stack
            return result
        }
    }

    public static async importHotels(rows: HotelImportModel[], dispatch: any) {
        const request = { hotels: rows }
        const result = await apiCallWrapper<HotelsImportResultModel>('/api/hotels/import', 'POST', dispatch, request)
        if (result.Content) {
            result.Content = HotelsImportResultModel.Create(result.Content)
        }
        return result
    }
}